var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hospital (1) 2",
    clipPath: "url(#clip0_1193_4596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 0C21.7315 0 28 6.26847 28 14C28 21.7306 21.7315 28 14 28C6.26847 28 0 21.7314 0 14C0 6.26857 6.26757 0 14 0Z",
    fill: "#84D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.87408 11.3775H11.3872V7.87404C11.3872 7.39108 11.7784 6.99902 12.2613 6.99902H15.7578C16.2399 6.99902 16.631 7.39098 16.631 7.87404V11.3767H20.1258C20.6096 11.3767 21.0008 11.7678 21.0008 12.2517V15.7525C21.0008 16.2373 20.6096 16.6293 20.1258 16.6293H16.631V20.1222C16.631 20.6061 16.2398 20.9972 15.7578 20.9972H12.2613C11.7784 20.9972 11.3872 20.6061 11.3872 20.1222V16.6293H7.87408C7.39023 16.6293 6.99817 16.2373 6.99817 15.7525V12.2517C6.99817 11.7686 7.39023 11.3775 7.87408 11.3775Z",
    fill: "#16B1FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1193_4596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalSvg);
export default __webpack_public_path__ + "static/media/HospitalSvg.379ee87232b76d8b4c865776f3b1c82e.svg";
export { ForwardRef as ReactComponent };